/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadStopStatus = {
    Pending: 'PENDING',
    GoodToGo: 'GOOD_TO_GO',
    OnRoute: 'ON_ROUTE',
    Arrived: 'ARRIVED',
    Completed: 'COMPLETED',
    Passed: 'PASSED'
} as const;
export type LoadStopStatus = typeof LoadStopStatus[keyof typeof LoadStopStatus];

